import React from 'react';
import { TrashSVG } from '../../@common_components/svgs/trash.svg';

const TrashIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <TrashSVG {...props} />;
};

export { TrashIcon };
